/**
 * defa.behaviors.ViewAnimator
 * A class for animating most views both in and out.
 * @version 1.0.9
 */
	
const animationTime = 230;

const spinner =
`<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
	<circle class="path" stroke="#6d8f6c" fill="none" stroke-width="4" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>`;
	
const ViewAnimator = Mn.Behavior.extend({
		
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
		
	channelName: 'layout',
		
	radioEvents: {
		'idle' : 'idle',
	},
		
		
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
		
	/**
		 * @constructor
		 */
	initialize: function( options ) {
		this.options = options || {};
			
		this.view.listenTo( this.view, 'animateOut', this.view.destroy );
			
		this.view.animateIn  = this.animateIn;
		this.view.animateOut = this.animateOut;
		this.view.busy       = this.busy;
		this.view.dim        = this.dim;
		this.view.idle       = this.idle;
		this.view.isBusy     = this.isBusy;
	},
		
	/**
		 * Triggers just before the element is attached to the DOM.
		 * @void
		 */
	onRender: function() {
		let noAnimate = this.view.noAnimate || this.view.options.noAnimate;
		
		if ( ! noAnimate ) {
			this.animateIn();
		}
	},
		
		
		
	// ------------------------------------------------
	// Functions
	// ------------------------------------------------
		
	/**
		 * Animates the element into the screen.
		 * @void
		 */
	animateIn: function(/* event */) {
		let self = this;
			
		self.trigger( 'before:animateIn', self );
		self.$el.addClass( 'animate-in' );
			
		setTimeout( function() {
			self.$el.removeClass( 'animate-in' );
			self.trigger( 'animateIn', self );
		}, animationTime );
	},
		
	/**
		 * Animates the element out of the screen.
		 * @void
		 */
	animateOut: function( closeLink ) {
			
		let self = this;
			
		// as long as the closeLink exists, set it.
		if ( ! _.isUndefined( closeLink )) {
			self.closeLink = closeLink;
		}
			
		self.trigger( 'before:animateOut', self );
		self.$el.addClass( 'animate-out' );
			
		setTimeout( function() {
			self.trigger( 'animateOut', self );
		}, animationTime );
	},
		
	/**
		 * Fades out the view and shows a working spinner
		 * @void
		 */
	busy: function() {
			
		if ( ! this.noBusy ) {
			this.trigger( 'before:busy', this );
			this.$el.addClass( 'faded' ).append( spinner );
			this.$('.radio-strip-wrap').attr('disabled', true); // Disabling sliders, should incude a variable names hasSliders in the view poppet model?
			this.trigger( 'busy', this );
		}
	},
		
	/**
		 * Dims the entire view
		 * @void
		 */
	dim: function() {
		this.trigger( 'before:dim', this );
		this.$el.addClass( 'faded dim' );
		this.trigger( 'dim', this );
	},
		
	/**
		 * Removes any faded effect and/or spinner from the view.
		 * @void
		 */
	idle: function() {
		this.trigger( 'before:idle', this );
		// remove effects and spinner
		this.$el.removeClass( 'faded dim' );
		this.$el.find( '.spinner' ).remove();
		this.$('.radio-strip-wrap').attr('disabled', false);
		// remove focus from activeElement.
		// channelLayout.trigger( 'idle' );
			
		this.trigger( 'idle', this );
	},

	isBusy: function() {
		return (this.$el.find('.spinner').length > 0);
	},
		
});
	
export default ViewAnimator;
	